"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenState = void 0;
var ScreenState;
(function (ScreenState) {
    ScreenState["Tracks"] = "tracks";
    ScreenState["Playlists"] = "playlists";
})(ScreenState || (exports.ScreenState = ScreenState = {}));
